import { bool, func, string } from 'prop-types'
import { Link } from 'redux-little-router'
import React from 'react'

const Option = (props) => {
  return (
    <li>
      {!props.isChecked &&
        <Link
          href={props.href}
          onClick={props.onClick}
          replaceState
        >
          {!props.hideCheckbox &&
            <div className="checkbox">
              <i />
            </div>
          }
          <div>{props.name}</div>
        </Link>
      }
      {props.isChecked &&
        <Link
          className="is-checked"
          href={props.href}
          onClick={props.onClick}
          replaceState
        >
          {!props.hideCheckbox &&
            <div className="checkbox">
              <i />
            </div>
          }
          <div>{props.name}</div>
        </Link>
      }
    </li>
  )
}
Option.defaultProps = {
  hideCheckbox: false,
}
Option.propTypes = {
  hideCheckbox: bool,
  href: string.isRequired,
  isChecked: bool.isRequired,
  name: string.isRequired,
  onClick: func.isRequired,
}

export default Option
